"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAutocompleteEditCellListbox = exports.StyledAutocompleteEditCellPaper = exports.StyledAutocompleteEditCellPopper = exports.StyledAutocompleteEditCell = exports.StyledAutocompleteEditCellWrapper = void 0;
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledAutocompleteEditCellWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
`;
exports.StyledAutocompleteEditCell = (0, styled_components_1.default)(material_1.Autocomplete) `
  && {
    width: 100%;
    height: 100%;
    font-size: inherit;
    line-height: inherit;

    .MuiFormControl-root {
      width: 100%;
      height: 100%;
    }

    .MuiInputBase-root.MuiOutlinedInput-root {
      min-height: calc(var(--height, 42px) - 1px);
      height: calc(var(--height, 42px) - 1px);
      padding: 0 12px;
      border-radius: 0;
      background: transparent;
      box-shadow: none;
      font-size: inherit;
      line-height: inherit;
    }

    .MuiAutocomplete-inputRoot.MuiOutlinedInput-root {
      padding-right: 56px !important;
    }

    &.non-clearable .MuiAutocomplete-inputRoot.MuiOutlinedInput-root {
      padding-right: 32px !important;
    }

    .MuiAutocomplete-input {
      padding: 0 !important;
      font-size: inherit;
      line-height: inherit;
    }

    .MuiOutlinedInput-notchedOutline {
      border: 0 !important;
    }

    .MuiAutocomplete-endAdornment {
      right: 8px;
      display: inline-flex;
      align-items: center;
      gap: 2px;
    }

    .MuiAutocomplete-clearIndicator,
    .MuiAutocomplete-popupIndicator {
      padding: 2px;
    }

    &.non-searchable {
      .MuiAutocomplete-input {
        opacity: 0;
        width: 1px !important;
        min-width: 1px !important;
        caret-color: transparent;
      }

      .MuiAutocomplete-inputRoot {
        cursor: pointer;
      }
    }

    .autocomplete-edit-cell-display-value {
      display: inline-flex;
      align-items: center;
      min-width: 0;
      overflow: hidden;
      pointer-events: none;
      font-size: inherit;
      line-height: inherit;
    }
  }
`;
exports.StyledAutocompleteEditCellPopper = (0, styled_components_1.default)(material_1.Popper) `
  && {
    width: max-content !important;
    min-width: 160px;
    max-width: min(520px, calc(100vw - 32px));
    font-size: inherit;
    line-height: inherit;
  }
`;
exports.StyledAutocompleteEditCellPaper = (0, styled_components_1.default)(material_1.Paper) `
  && {
    margin: 0;
    padding: 4px;
    box-shadow: ${ui_components_1.shadows.backgroundCardHover};
    border-radius: 8px;
    font-size: inherit;
    line-height: inherit;

    .MuiAutocomplete-listbox,
    .MuiAutocomplete-listbox.MuiMenu-list {
      padding: 0;
    }

    .MuiAutocomplete-loading {
      margin: 0;
      padding: 16px;
      color: inherit;
    }

    .MuiAutocomplete-option {
      min-height: 40px;
      padding: 8px 12px;
      border-radius: 0;
      display: flex;
      align-items: center;
      color: ${ui_components_1.baseColors.primaryBlueDark500};
      font-size: inherit;
      line-height: 1.25;
    }

    .Mui-focused,
    .Mui-focused.MuiAutocomplete-option,
    .MuiAutocomplete-option[aria-selected='true'] {
      background-color: ${ui_components_1.baseColors.primaryGreen000};
      color: ${ui_components_1.baseColors.primaryGreen700};
    }
  }
`;
exports.StyledAutocompleteEditCellListbox = styled_components_1.default.ul `
  margin: 0;
  padding: 0;
  list-style: none;

  .autocomplete-edit-cell-dropdown-loading {
    display: flex;
    justify-content: center;
    padding: 8px 0;
  }

  .load-more-indicator {
    padding: 8px;
  }
`;
